export type UserItemContent = {
  readonly key: string;
  readonly accountId: string;
  readonly displayName: string | undefined;
  readonly avatarName: string;
  readonly avatarUrl: string | undefined;
  readonly status: 'loading' | 'ready' | 'unavailable' | 'error';
};

/**
 * Immutable ordered User presentation.
 */
export type UserReadContent = {
  readonly kind: 'user';
  readonly users: readonly UserItemContent[];
};

export const EMPTY_USER_CONTENT: UserReadContent = Object.freeze({
  kind: 'user',
  users: Object.freeze([])
});
